@if (initialized && dto) {
    @if (activeNavigationItems?.action == 'authTypes') {
        <div class="p-3">
            @if (authTypeWidget) {
                <mvs-widget
                        [widgetData]="authTypeWidget"
                        (onObjectSelect)="handleObjectSelect($event)">
                </mvs-widget>
            }
        </div>
    }

    @if (activeNavigationItems?.action == 'systemShipments') {
        <div class="p-3">
            @if (systemShipmentWidget) {
                <mvs-widget
                        [widgetData]="systemShipmentWidget"
                        (onObjectSelect)="handleObjectSelect($event)">
                </mvs-widget>
            }
        </div>
    }
}
